module.exports = __webpack_public_path__ + "static/1-590636bcb8fe95c9c6bf14d69d7c45ed.jpg";